import React from 'react';
import { InputAdornment, TextField, Typography, Container, Grid, Box } from "@mui/material";
import Paper from '@mui/material/Paper';
import { Tabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import injupemplogogobierno from '../../../img/injupemplogogobierno.png';
import { AntTabs, AntTab } from '../tabs_style';

export default function ComparativaLeyAnterior() {
  const [tabIndex, setTabIndex] = React.useState(8);
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const CommonBox = ({ children }) => (
    <Box display="flex" flexDirection="row" alignItems="center" style={{ margin: '10px 0', width: '60%' }}>
      {children}
    </Box>
  );

  const CommonLabel = ({ text }) => (
    <label style={{ marginRight: '10px', minWidth: '150px' }}>
      <b>{text}</b>
    </label>
  );

  const CommonTextField = ({ id }) => (
    <TextField
      id={id}
      style={{ flex: 1 }}
      InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
    />
  );

  return (
    <>
      <Grid container direction="column" alignItems="center">
        <Container>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <h2>Comparativa Devolución 10%</h2>
          </div>
        </Container>
        <Container>
          <Box sx={{ position: 'sticky', top: 0, zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Paper square>
              <AntTabs
                value={tabIndex}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{
                  style: { display: 'none' }, // O también puedes usar display: 'none' aquí
              }}
              >
                <AntTab label="Resumen" />
                <AntTab label="Tabla De Interés" />
                <AntTab label="Tasas Por Año" />
                <AntTab label="Monto Del Beneficio" />
                <AntTab label="Datos" />
                <AntTab label="Cálculos" />
                <AntTab label="Rebajas" />
                <AntTab label="Períodos" />
                <AntTab label="Comparativa Devolución 10%" />
                <AntTab label="Con Reingreso" />
              </AntTabs>
            </Paper>
          </Box>

          <Box mt={3}>
            {/* Contenido de la pestaña actual */}
            {tabIndex === 0 && navigate('/Separaciones/ResumenLeyAnterior')}
            {tabIndex === 1 && navigate('/Separaciones/TablaDeInteresLeyAnterior')}
            {tabIndex === 2 && navigate('/Separaciones/TasasLeyAnterior')}
            {tabIndex === 3 && navigate('/Separaciones/MontoDelBeneficioLeyAnterior')}
            {tabIndex === 4 && navigate('Separaciones/LeyAnterior')}
            {tabIndex === 5 && navigate('/Separaciones/CalculosLeyAnterior')}
            {tabIndex === 6 && navigate('/Separaciones/RebajasLeyAnterior')}
            {tabIndex === 7 && navigate('/Separaciones/PeriodosLeyAnterior')}
            {tabIndex === 8}
            {tabIndex === 9 && navigate('/Separaciones/ConReingresoLeyAnterior')}
          </Box>
        </Container>
      </Grid>

      <Box display="flex" flexDirection="column" alignItems="center">
        <CommonBox>
          <CommonLabel text="Monto Pagado:" />
          <CommonTextField id="MontoPagado" />
        </CommonBox>

        <CommonBox>
          <CommonLabel text="Retención Del 10%:" />
          <CommonTextField id="Retencion" />
        </CommonBox>

        <CommonBox>
          <CommonLabel text="Monto del Beneficio Nuevo Cálculo:" />
          <CommonTextField id="MontoNuevoCalculo" />
        </CommonBox>

        <CommonBox>
          <CommonLabel text="Valor a Devolver:" />
          <CommonTextField id="ValorDevolver" />
        </CommonBox>

        <CommonBox>
          <CommonLabel text="Diferencia:" />
          <CommonTextField id="Diferencia" />
        </CommonBox>

      </Box>

    </>
  );
}
